const LeavesLoader = () => {
  return (
    <svg
      width="39"
      height="35"
      viewBox="0 0 39 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animate-spin"
    >
      <path
        d="M20.9033 27.0697C20.418 28.9458 19.4577 30.7523 21.7018 31.3329C29.9272 33.4611 35.8266 24.6857 37.7719 17.6712C37.8262 17.4754 37.6734 17.2871 37.4704 17.2971C30.6562 17.6327 22.7499 19.933 20.9033 27.0697Z"
        fill="#809859"
        stroke="#4D6547"
        stroke-width="1.21382"
        stroke-linecap="round"
      />
      <path
        d="M32.4467 21.4546C31.1951 22.8371 28.6479 25.5826 27.2845 26.8678C25.583 28.4717 23.0217 30.4346 20.5649 30.3621C19.741 30.792 17.4933 31.652 15.0933 31.652"
        stroke="#4D6547"
        stroke-width="1.21382"
        stroke-linecap="round"
      />
      <path
        d="M18.3887 8.3085C18.9173 6.4442 19.9191 4.66037 17.689 4.02804C9.51494 1.71035 3.41428 10.3471 1.30745 17.3147C1.24862 17.5093 1.39703 17.701 1.60022 17.6957C8.4203 17.5176 16.3777 15.4007 18.3887 8.3085Z"
        fill="#809859"
        stroke="#4D6547"
        stroke-width="1.21382"
        stroke-linecap="round"
      />
      <path
        d="M6.71893 13.6557C8.00211 12.3025 10.6121 9.61666 12.0048 8.3633C13.7429 6.79917 16.3489 4.89595 18.8034 5.02523C19.6369 4.61441 21.9039 3.80665 24.3033 3.86211"
        stroke="#4D6547"
        stroke-width="1.21382"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default LeavesLoader
